<template>
  <div>
    <h1>Veri bulunamadı...</h1>
  </div>
</template>

<script>
  export default {
    name: 'DataNotFound',  
  }
</script>

<style scoped>
  h1{
    text-align: center;
		color: gray;
		font-size: 4vw;
  }
</style>